var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgItemWrapper(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 230,
    viewBox: "0 0 164 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_150)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.5 1V0.5H163H13H12.7929L12.6464 0.646447L6.64645 6.64645L0.646447 12.6464L0.5 12.7929V13V229V229.5H1H151H151.207L151.354 229.354L157.354 223.354L163.354 217.354L163.5 217.207V217V1Z",
    stroke: "url(#paint0_linear_0_150)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_150",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 162,
    height: 228
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7L13 1H163V217L157 223L151 229H1V13L7 7Z",
    fill: "#040F24"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_150)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 189,
    width: 162,
    height: 40,
    fill: "#1B2030"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_150",
    x1: 123,
    y1: 154,
    x2: 6,
    y2: 0.999988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0104167,
    stopColor: "#425687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#FF7510"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#FF9E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#425687"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 164,
    height: 230,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemWrapper);
export default __webpack_public_path__ + "static/media/item-wrapper.0e7b725898ffc2c345bcfd70aad899d0.svg";
export { ForwardRef as ReactComponent };